module.exports = __webpack_public_path__ + "static/media/ic1_document@2x.b41e696a.png";